import {
  INGREDIENT,
  getPostsByLanguage,
  getMultiLanguagePostMapping,
  fetchByCategory,
  fetchByCategoryAndId,
  fetchCategories,
  getIngredientCategoryNames,
  fetchBySlug,
} from "../utils.api";
import { parseIngredientLanguageIds } from "../utils.reducer";

const USE_INGREDIENT_SLUG =
  process.env.REACT_APP_USE_INGREDIENT_SLUG === "TRUE";

export const locationApi = async () => {
  const data = await fetchCategories();
  const ingredientCategories = getIngredientCategoryNames(data, "ingredient");
  return ingredientCategories;
};

export const ingredientByLocationApi = async (location) => {
  const ingredientLocations = `${location}-ingredient`;
  const [locationCategory] = await fetchCategories(
    `slug=${ingredientLocations}`,
  );
  const locationId = locationCategory.id;

  const data = await fetchByCategory(locationId);
  const dataNoTranslate = getPostsByLanguage(data);

  const postPairs = dataNoTranslate.map((post) => {
    const { id, slug } = post;

    if (USE_INGREDIENT_SLUG) {
      const languageIds = parseIngredientLanguageIds(post);
      const languagePosts = {};
      Object.entries(languageIds).forEach(([lang, langId]) => {
        const match = data.find((p) => p.id === langId);
        if (match) languagePosts[lang] = match;
      });
      return {
        id,
        slug,
        location,
        ingredient: slug,
        vn: post,
        languageIds,
        ...languagePosts,
      };
    }

    return {
      id,
      location,
      ingredient: slug,
      vn: post,
      ...getMultiLanguagePostMapping(post, data, slug),
    };
  });

  return postPairs;
};

export const ingredientDetailsApi = async (ingredientId) => {
  const data = await fetchByCategoryAndId(INGREDIENT, ingredientId);
  const { id, slug, content } = data;
  return { id, slug, content };
};

export const ingredientDetailBySlugApi = async (slug) => {
  const results = await fetchBySlug(slug);
  if (!results.length) return null;

  const post = results[0];
  const languageIds = parseIngredientLanguageIds(post);
  const { id, slug: wpSlug, content } = post;
  return { id, slug: wpSlug, content, languageIds };
};
